import React from 'react';

import { Breadcrumbs, Link, Typography } from '@mui/material';

interface Props {
  roomTypeName: string;
  currentPage?: string;
  onNavigateToRoomTypes: () => void;
  onNavigateToRoomType?: () => void;
}

export default function RoomTypeBreadcrumbs({
  roomTypeName,
  currentPage,
  onNavigateToRoomTypes,
  onNavigateToRoomType,
}: Props) {
  return (
    <Breadcrumbs sx={{ mb: 2 }}>
      <Link component="button" type="button" onClick={onNavigateToRoomTypes} underline="hover">
        Rates and Inventory
      </Link>
      {currentPage ? (
        <Link component="button" type="button" onClick={onNavigateToRoomType} underline="hover">
          {roomTypeName}
        </Link>
      ) : (
        <Typography color="text.primary">{roomTypeName}</Typography>
      )}
      {currentPage && <Typography color="text.primary">{currentPage}</Typography>}
    </Breadcrumbs>
  );
}
